/**
 * StarIcon — auto-generated by scripts/generate-icons.ts.
 * Do NOT edit manually — re-run `yarn codegen:icons` to regenerate.
 */

// SVGProps is used by the SVGR-generated component below.
import type { SVGProps } from 'react'
import { makeIcon } from '../make-icon'

interface SVGRProps {
  title?: string
  titleId?: string
}
const StarIconSvg = ({ title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path d="m16.234 13.95 5.58-4.07a.5.5 0 0 0-.3-.93h-6.89l-2.13-6.54a.51.51 0 0 0-1 0l-2.09 6.54h-6.89a.5.5 0 0 0-.3.91l5.58 4.09-2.13 6.54a.5.5 0 0 0 .77.56l5.58-4.1 5.58 4.06a.5.5 0 0 0 .77-.56z" />
  </svg>
)

/** @see {@link https://design.reapit.com.au} Reapit DS icon */
export const StarIcon = makeIcon('StarIcon', StarIconSvg)
